"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _useControlledState2 = _interopRequireDefault(require("../../hooks/useControlledState"));

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Switch = function Switch(_ref) {
  var children = _ref.children,
      switchPosition = _ref.switchPosition,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      externalIsActive = _ref.isActive,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "switchPosition", "disabled", "onClick", "isActive"]);

  var _useControlledState = (0, _useControlledState2["default"])(externalIsActive, onClick),
      isActive = _useControlledState[0],
      setIsActive = _useControlledState[1];

  return (0, _themeUi.jsx)("button", _extends({}, props, {
    role: "switch",
    "aria-checked": isActive,
    "aria-readonly": disabled,
    onClick: function onClick() {
      setIsActive(!isActive);
    },
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }), switchPosition === 'right' && (0, _themeUi.jsx)(_Text["default"], {
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, children), (0, _themeUi.jsx)("span", {
    sx: {
      height: '20px',
      width: '36px',
      position: 'relative',
      mr: children && switchPosition === 'left' ? 3 : 0,
      ml: children && switchPosition === 'right' ? 3 : 0
    }
  }, (0, _themeUi.jsx)("span", {
    sx: {
      left: '1px',
      top: '3px',
      height: '14px',
      width: '34px',
      bg: isActive ? 'secondaryHover' : 'blackDisabled',
      position: 'absolute',
      borderRadius: 'large',
      transition: function transition(theme) {
        return "background-color 250ms " + theme.easing.quickToSlow;
      }
    }
  }), (0, _themeUi.jsx)("span", {
    sx: {
      width: '20px',
      height: '20px',
      bg: isActive ? 'secondary' : 'neutral.0',
      position: 'absolute',
      top: 0,
      left: 0,
      transform: isActive ? 'translateX(16px)' : 'translateX(0px)',
      borderRadius: 'large',
      boxShadow: 0,
      transition: function transition(theme) {
        return "transform 250ms " + theme.easing.quickToSlow + ", background-color 250ms " + theme.easing.quickToSlow;
      }
    }
  })), switchPosition === 'left' && (0, _themeUi.jsx)(_Text["default"], null, children));
};

Switch.propTypes = {
  name: _propTypes["default"].string,
  children: _propTypes["default"].node,
  switchPosition: _propTypes["default"].oneOf(['left', 'right']),
  isActive: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func
};
Switch.defaultProps = {
  children: null,
  switchPosition: 'right',
  isActive: false,
  disabled: false,
  onClick: null
};
var _default = Switch;
exports["default"] = _default;